"use strict";
/**
 * 日期顯示（docs/介面優化.md §3-2、R17）
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTableDate = exports.toIntlLocale = void 0;
/** i18n 語言代碼 → Intl locale */
const toIntlLocale = (language = 'zh') => language === 'zh' ? 'zh-TW' : language === 'ja' ? 'ja-JP' : 'en-US';
exports.toIntlLocale = toIntlLocale;
/**
 * 表格日期：一律絕對時間，同年不帶年份
 * 例：zh「10/7」、跨年「2025/12/31」
 */
const formatTableDate = (value, language = 'zh') => {
    if (!value)
        return '';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime()))
        return '';
    const sameYear = date.getFullYear() === new Date().getFullYear();
    return date.toLocaleDateString((0, exports.toIntlLocale)(language), sameYear
        ? { month: 'numeric', day: 'numeric' }
        : { year: 'numeric', month: 'numeric', day: 'numeric' });
};
exports.formatTableDate = formatTableDate;
